export function CapReachedBadge() {
  return (
    <span
      className={
        "rounded-md bg-amber-100 px-1.5 py-0.5 text-xs font-medium text-amber-700"
      }
    >
      Cap reached
    </span>
  );
}
